import { Clickable, Col, H3, P, Row } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';

import { FRAGMENTS, SLUG } from '../../models/table-of-contents/constants';
import { StyledDiv, StyledImage, StyledImageWrapper, StyledWrapper } from './styles';
import constants from '../../ahm-constants';
import useTableOfContents from '../../cms/utils/use-table-of-contents';

const Awards = (): JSX.Element | null => {
  const { items: awards } = useTableOfContents({
    fragment: FRAGMENTS.AWARDS,
    skip: false,
    slug: SLUG.AWARDS,
  });

  if (awards.length === 0) {
    return null;
  }

  return (
    <Row isBoxed>
      <Col df={12}>
        <StyledWrapper variant={['marginTopSpacer4', 'marginBottomSpacer4']}>
          <StyledDiv>
            <H3 variant={['simpleBit', 'center']}>We‘re award winners for many of our insurance products.</H3>
            <StyledImageWrapper itemCount={awards.length}>
              {map(
                (award) => (
                  <StyledImage src={award.item.imageObject.image.asset.url} alt={award.name} />
                ),
                awards,
              )}
            </StyledImageWrapper>
            <P variant="center">
              These are some of our faves.{' '}
              <Clickable to={`${constants.URLS.SALES.EXPLAINED}/why-ahm`}>
                Learn why our products were voted winners.
              </Clickable>
            </P>
          </StyledDiv>
        </StyledWrapper>
      </Col>
    </Row>
  );
};

export default Awards;
